import React, { useState, Suspense, useEffect } from 'react';
import {Route, Routes, Navigate, useLocation, useParams  } from 'react-router-dom';
import TopBarProgress from 'react-topbar-progress-indicator'
import axios from 'axios'

import SystemAdminLayout from '../../_template/layout/SystemAdminLayout';
import Agents from '../pages/admin/agents/Agents';
import ErrorPage from '../pages/error/ErrorPage';
import Dashboard from '../pages/systemAdmin/systemAdminDashboard/Dashboard';
import ReceivedRequest from '../pages/systemAdmin/receivedRequest/ReceivedRequest';
import ManageVirtualAgent from '../pages/admin/manageAgent/ManageVirtualAgent';
import { CdrReport, MissedChat } from '../pages/admin/report';
import LiveAssistant from '../pages/admin/liveAssistant/LiveAssistant';
import Overview from '../pages/admin/guide/overview/Overview';
import Concepts from '../pages/admin/guide/concepts/Concepts';
import Channels from '../pages/admin/guide/channels/Channels';
import Deployments from '../pages/admin/guide/deployments/Deployments';
import BestPractices from '../pages/admin/guide/bestPractices/BestPractices';
import TruChatWidget from '../pages/admin/guide/truChatWidget/TruChatWidget';
import WidgetIntegration from '../pages/admin/guide/widgetIntegration/WidgetIntegration';
import SystemUser from '../pages/admin/systemUser/SystemUser';
import Billing from '../pages/admin/billing/Billing';
import Cms from '../pages/systemAdmin/cms/Cms';
import { AgentAnalytics, BotAnalytics, ChatAnalytics } from '../pages/admin/analytics';
import SystemAdminReg from '../pages/systemAdmin/systemAdminReg/SystemAdminReg';

import PricingModule from '../pages/systemAdmin/cms/pages/pricingModule/PricingModule';
import ManageVideo from '../pages/systemAdmin/cms/pages/manageVideo/ManageVideo';

const SuspensedView = ({children}) => {
    const location = useLocation();
    const [progress, setProgress] = useState(true);
    TopBarProgress.config({
        barColors: {
            "0": '#f61616',
        },
        barThickness: 2,
        shadowBlur: 5,
    });

    useEffect(() => {
        setProgress(true);
        const timer = setTimeout(() => setProgress(false), 500);
        return () => clearTimeout(timer);
    }, [location]);

    return (
        <>
            {progress && <TopBarProgress />}
            <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
        </>
    );
}
const SystemAdminRoutes = () => {
    //const { company } = useParams();
    //const [isValidCompany, setIsValidCompany] = useState(true);

    const location = useLocation();
    const slugMatch = location.pathname.match(/^\/system-admin\/([^/]+)\/(agents|report)/);
    const dynamicCompany = slugMatch?.[1];
    
    const loginUserType = localStorage.getItem('type');
    const [visible, setVisible] = useState(true);
    const [businessDetails, setBusinessDetails] = useState(null);
    const [isValidSubdomain, setIsValidSubdomain] = useState(true);
   
    useEffect(() => {
        const getBusinessDetails = async() => {
            if (!dynamicCompany) return;
            try {
                const api_headers = {
                    headers: { 
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        "x-access-token" : localStorage.getItem('systemAdminToken')
                    }
                };
                const api_params = {
                    sub_domain: dynamicCompany,
                    user_name: localStorage.getItem("system_username")
                }
                await axios.post(`${process.env.REACT_APP_API_URL}admin/valid-subdomains-permission`, api_params, api_headers)
                .then(async (res) => {
                    if(res.data.status === 'success') {
                        if(res.data.data.businessData.length > 0){
                            setBusinessDetails(res.data.data.businessData[0]);
                            setIsValidSubdomain(true);
                            setVisible(false)
                            localStorage.setItem('sass_id', res.data.data.businessData[0].sass_id);
                            localStorage.setItem('subdomain', res.data.data.businessData[0].biz_app_url);
                            localStorage.setItem('business_name', res.data.data.businessData[0].business_name);
                            localStorage.setItem('business_email', res.data.data.businessData[0].biz_email);
                        } else {
                            setBusinessDetails(null);
                            setIsValidSubdomain(false);
                            setVisible(false)
                        }
                    } else if(res.data.status === 'error') {
                        setIsValidSubdomain(false);
                        setVisible(false)
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
            } catch (error2) {
                console.error(error2)
            }  
        }
        getBusinessDetails();
    }, [dynamicCompany]);

    if (!isValidSubdomain && dynamicCompany) {
        return <Navigate to="error" />;
    }

    return (
        <>
            <Routes>
                <Route index element={<Navigate to='dashboard' />} />
                <Route element={<SystemAdminLayout />}>
                    <Route path='received-request' element={
                        <SuspensedView>
                            <ReceivedRequest />
                        </SuspensedView>
                    } />
                    <Route element={<Cms />}>
                        <Route path='cms/manage-pricing-module' element={
                            <SuspensedView>
                                <PricingModule />
                            </SuspensedView>
                        } />
                        <Route path='cms/manage-video' element={
                            <SuspensedView>
                                <ManageVideo />
                            </SuspensedView>
                        } />
                    </Route>
                    <Route path='dashboard' element={
                        <SuspensedView>
                            <Dashboard />
                        </SuspensedView>
                    } />
                    <Route path='reg-sys-admin' element={
                        <SuspensedView>
                            <SystemAdminReg />
                        </SuspensedView>
                    } />
                    <Route path=':company/agents' element={
                        <SuspensedView>
                            <Agents />
                        </SuspensedView>
                    } />
                    <Route path=':company/agents/manage-virtual-agent' element={
                        <SuspensedView>
                            <ManageVirtualAgent />
                        </SuspensedView>
                    }/>
                    <Route path=':company/agents/manage-virtual-agent/:param_bot_id' element={
                        <SuspensedView>
                            <ManageVirtualAgent />
                        </SuspensedView>
                    }/>
                    <Route path=':company/guide/overview' element={
                        <SuspensedView>
                            <Overview />
                        </SuspensedView>
                    }/>
                    <Route path=':company/guide/concepts' element={
                        <SuspensedView>
                            <Concepts />
                        </SuspensedView>
                    }/>
                    <Route path=':company/guide/channels' element={
                        <SuspensedView>
                            <Channels />
                        </SuspensedView>
                    }/>
                    <Route path=':company/guide/deployments' element={
                        <SuspensedView>
                            <Deployments />
                        </SuspensedView>
                    }/>
                    <Route path=':company/guide/best-practices' element={
                        <SuspensedView>
                            <BestPractices />
                        </SuspensedView>
                    }/>
                    <Route path=':company/truchat-widget' element={
                        <SuspensedView>
                            <TruChatWidget />
                        </SuspensedView>
                    }/>
                    <Route path=':company/guide/widget-integration' element={
                        <SuspensedView>
                            <WidgetIntegration />
                        </SuspensedView>
                    }/>
                    <Route path=':company/report/cdr-report' element={
                        <SuspensedView>
                            <CdrReport />
                        </SuspensedView>
                    } />
                    <Route path=':company/report/missed-chat' element={
                        <SuspensedView>
                            <MissedChat />
                        </SuspensedView>
                    } />
                    <Route path=':company/system-user' element= {
                        <SuspensedView>
                            <SystemUser />
                        </SuspensedView>
                    }/>
                    <Route path=':company/billing' element={
                        <SuspensedView>
                            <Billing />
                        </SuspensedView>
                    }/>
                    <Route path=':company/live-assistant' element={
                        <SuspensedView>
                            <LiveAssistant />
                        </SuspensedView>
                    }/>
                    <Route path=':company/analytics/agent-analytics' element={
                        <SuspensedView>
                            <AgentAnalytics />
                        </SuspensedView>
                    }/>
                    <Route path=':company/analytics/bot-analytics' element={
                        <SuspensedView>
                            <BotAnalytics />
                        </SuspensedView>
                    }/>
                    <Route path=':company/analytics/chat-analytics' element={
                        <SuspensedView>
                            <ChatAnalytics />
                        </SuspensedView>
                    }/>
                </Route>
                <Route path='error' element={<ErrorPage />} />
                <Route path="*" element={<Navigate to="error" replace />} />
            </Routes>
        </>
    )
}

export default SystemAdminRoutes